export default {
  accountInfo: {},
  logged: false,
  listLanguage: {},
};
